import React from "react";

export default () => (
  <svg
    viewBox="0 0 29 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[20.5px] h-[20.75px]"
  >
    <path
      d="M8.3125 16.625H10.375V11.125H8.3125V12.8438H6.25V14.9063H8.3125V16.625ZM11.75 14.9063H22.75V12.8438H11.75V14.9063ZM18.625 11.125H20.6875V9.40625H22.75V7.34375H20.6875V5.625H18.625V11.125ZM6.25 9.40625H17.25V7.34375H6.25V9.40625ZM9 24.875V22.125H3.5C2.74375 22.125 2.09613 21.8555 1.55713 21.3165C1.01813 20.7775 0.749086 20.1303 0.750002 19.375V2.875C0.750002 2.11875 1.0195 1.47113 1.5585 0.932127C2.0975 0.393127 2.74467 0.124086 3.5 0.125002H25.5C26.2563 0.125002 26.9039 0.394502 27.4429 0.933502C27.9819 1.4725 28.2509 2.11967 28.25 2.875V19.375C28.25 20.1313 27.9805 20.7789 27.4415 21.3179C26.9025 21.8569 26.2553 22.1259 25.5 22.125H20V24.875H9Z"
      fill="#545454"
    />
  </svg>
);
